import React from 'react';
import { appMethod as app } from '@utils/app';
import util from '@utils/util';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import * as customEvent from '@utils/customEvent';

import { MemberDiscount } from 'src/common/member-discount/MemberDiscount';

import OfficialPage from '../OfficialPage';
import { TopNav } from '@common/top-nav/TopNav';
import './DiningOrderDetail.less';

export default class DiningOrderDetail extends OfficialPage {
  state = {
    pageData: {
      useBalance: true,
      selectDiscountInfo: {},
      discountList: []
    },
    exchangeCouponData: {
      dialogHidden: true,
      goodsInfo: {},
      selectModelInfo: {},
      hasSelectGoods: false,
      voucher_coupon_goods_info: {}
    },
    changeOrder: false,
    showMoreBtn: false,
    showMoreGoods: false,
    showBenefitInfo: false,
    customNumArr: Array.from(new Array(101).keys()).slice(1),
    userToken: app.globalData.userInfo.user_token
  }
  franchisee_id = ''
  requesting = false
  pickUpType = 0

  memberDiscountRef = React.createRef();

  constructor(props) {
    super(props);
    document.title = '订单详情';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    let orderId = options.detail || ''
    this.franchisee_id = options.franchisee || ''
    this.setData({
      orderId: orderId,
      franchisee_id: this.franchisee_id,
      'pageData.useBalance': this.franchisee_id ? false : true
    })
  }

  componentDidMount() {
    this.dataInit()
  }

  onPullDownRefresh = () => {
    this.dataInit()
    setTimeout(() => {
      app.stopPullDownRefresh()
    }, 3000)
  }
  dataInit = () => {
    this.getDiningBaseSetting()
    this.getDiningFuncSetting()
    this.getOrderDetail(this.noticeMethod)
  }
  showBtnStyle = () => {
    let showBtnNum = 0
    this.data.pageData.allow_app_account ? showBtnNum++ : ''
    this.data.pageData.allow_add_dish &&
      this.data.pageData.orderInfo.status == 17
      ? showBtnNum++
      : ''
    this.data.pageData.orderInfo.goods_reduced_nums &&
      this.data.pageData.ec_dining_data.has_reduce_dishes
      ? showBtnNum++
      : ''
    this.setData({
      showBtnNum: showBtnNum
    })
  }
  showMoreBtn = () => {
    this.setData({
      showMoreBtn: !this.data.showMoreBtn
    })
  }
  getAppECStoreConfig = () => {
    app.getAppECStoreConfig(res => {
      this.setData({
        storeConfig: res,
        storeStyle: res.color_config
      })
    }, this.franchisee_id)
  }
  getOrderDetail = callback => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/getOrder',
      data: {
        order_id: this.data.orderId
      },
      method: 'post',
      success: function (res) {
        let orderInfo = res.data[0].form_data
        let ecommerce_info = orderInfo.ecommerce_info
        let diningOrderList = ecommerce_info.ecommerce_dining_child_order
        let goodsSum = 0
        let newData = {}
        let additional_goodsid_arr = []
        let additional_info_goods = []
        let hasAdditionalInfo = false
        let vip_goods_list = []
        if (orderInfo.additional_info) {
          for (var i = 0; i < orderInfo.goods_info.length; i++) {
            var deliveryId = orderInfo.goods_info[i].delivery_id,
              goodsId = orderInfo.goods_info[i].goods_id
            if (
              deliveryId &&
              deliveryId != '0' &&
              additional_goodsid_arr.indexOf(goodsId) == -1
            ) {
              additional_info_goods.push(orderInfo.goods_info[i])
              additional_goodsid_arr.push(goodsId)
              hasAdditionalInfo = true
            }
          }
          newData['hasAdditionalInfo'] = hasAdditionalInfo
          app.setPreviewGoodsInfo(additional_info_goods)
          app.setGoodsAdditionalInfo(orderInfo.additional_info || {})
        }
        for (let i = 0; i < diningOrderList.length; i++) {
          let data = diningOrderList[i].child_form_data
          for (let j = 0; j < data.length; j++) {
            goodsSum += data[j].goods_list.length
            for (let k = 0; k < data[j].goods_list.length; k++) {
              if (
                data[j].goods_list[k].model_value &&
                data[j].goods_list[k].model_value.length
              ) {
                data[j].goods_list[k].model_value_str = data[j].goods_list[
                  k
                ].model_value.join('|')
              }
            }
          }
        }
        orderInfo.goods_info.forEach((item, index) => {
          if (item.is_vip_goods) {
            if (item.model_value && item.model_value.length) {
              item.model_value_str = item.model_value.join('|')
            }
            if (ecommerce_info.ec_dining_data.account_type == 1) {
              if (item.refunded_num) {
                item.count = item.num - item.refunded_num
              } else {
                item.count = item.num
              }
            } else {
              item.count = item.num
            }
            vip_goods_list.push(item)
          }
        })
        if (Array.isArray(orderInfo.selected_benefit_info)) {
          newData['pageData.show_benefit_info'] = false
        } else {
          newData['pageData.show_benefit_info'] = true
        }
        newData['pageData.box_fee'] = orderInfo.box_fee
        newData['pageData.tissue_fee'] = orderInfo.tissue_fee
        newData['pageData.server_fee'] = orderInfo.server_fee
        newData['pageData.goodsSum'] = goodsSum
        newData['pageData.totalPayment'] = orderInfo.total_price
        newData['pageData.orderInfo'] = orderInfo
        newData['pageData.people_num'] = orderInfo.people_num
        newData['pageData.additional_info'] = orderInfo.additional_info
        newData['pageData.ec_dining_data'] = ecommerce_info.ec_dining_data
        newData['pageData.location_id'] =
          ecommerce_info.ec_dining_data.location_id || ''
        newData['pageData.account_type'] =
          ecommerce_info.ec_dining_data.account_type
        newData['pageData.dining_mode'] =
          ecommerce_info.ec_dining_data.dining_mode
        newData['pageData.diningOrderList'] =
          ecommerce_info.ecommerce_dining_child_order
        newData['vip_goods_list'] = vip_goods_list
        let coupon = orderInfo.selected_benefit_info
        if (!Array.isArray(coupon)) {
          if (coupon.discount_type == 'coupon' && coupon.benefit_type == 2) {
            newData['exchangeCouponData.selectModelInfo'] = coupon
            newData['exchangeCouponData.hasSelectGoods'] = true
            newData['exchangeCouponData.goodsInfo.cover'] = coupon.goods_img
            newData['exchangeCouponData.goodsInfo.title'] =
              coupon.goods_title || ''
            newData['exchangeCouponData.goodsInfo.model_value_str'] =
              coupon.model_name || ''
          }
        }
        that.pickUpType = orderInfo.pick_up_type
        that.setData(newData)
        ecommerce_info.ec_dining_data.account_type == 2
          ? that.showBtnStyle()
          : ''
        that.modifyTime(orderInfo)
        typeof callback == 'function' && callback()
      }
    })
  }
  noticeMethod = () => {
    let data = this.data.pageData
    let newData = {}
    if (data.account_type == 1 && data.orderInfo.status == 3) {
      data.ec_dining_data.location_id
        ? (newData['showNoticeModal'] = true)
        : (newData['showNoticeModal'] = false)
    } else {
      data.orderInfo.status == 17
        ? (newData['showNoticeModal'] = true)
        : (newData['showNoticeModal'] = false)
    }
    this.setData(newData)
  }
  showNoticeModalFn = () => {
    this.setData({
      showNoticeModal: false
    })
  }
  orderDelete = () => {
    var orderId = this.data.orderId,
      franchisee = this.franchisee_id,
      appId = app.getAppId(),
      subShopId = franchisee == app.getAppId() ? '' : franchisee,
      that = this
    app.showModal({
      content: '是否删除该订单？',
      showCancel: true,
      cancelText: '取消',
      confirmText: '确定',
      confirmColor: '#FF7100',
      confirm: function () {
        app.sendRequest({
          url: '/index.php?r=AppShop/HideOrder',
          data: {
            order_id: orderId,
            app_id: appId,
            sub_shop_app_id: subShopId
          },
          success: function (res) {
            app.turnBack()
          }
        })
      }
    })
  }
  orderCancel = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/cancelOrder',
      data: {
        order_id: this.data.orderId
      },
      success: function (res) {
        that.getOrderDetail()
      }
    })
  }
  goOrderProgress = () => {
    let orderId = this.data.orderId
    let franchiseeId = this.franchisee_id
    let pagePath =
      '/eCommerce/pages/goodsOrderProgress/goodsOrderProgress?orderId=' +
      orderId +
      (franchiseeId ? '&franchisee=' + franchiseeId : '')
    app.turnToPage(pagePath)
  }
  turnToRufundDish = () => {
    var orderId = this.data.orderId
    var type = this.data.pageData.account_type
    app.turnToPage(
      '/eCommerce/pages/refundDishesDetail/refundDishesDetail?detail=' +
      orderId +
      '&type=' +
      type
    )
  }
  turnToComment = e => {
    var orderId = this.data.orderId,
      franchiseeId = this.franchisee_id,
      queryStr =
        franchiseeId === app.getAppId() ? '' : '&franchisee=' + franchiseeId
    app.turnToPage(
      '/eCommerce/pages/makeComment/makeComment?detail=' + orderId + queryStr
    )
  }
  changeDiningOrder = () => {
    this.setData({
      changeOrder: true,
      showMoreBtn: false
    })
  }
  changeCustomNum = e => {
    let value = +e.target.value + 1
    if (value != this.data.pageData.people_num) {
      this.setData({
        'pageData.people_num': value
      })
      this.getCalculationInfo()
      this.changeOrderInfo()
    }
  }
  changeOrderInfo = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppEcommerce/ChangePeopleNum',
      data: {
        num: this.data.pageData.people_num,
        order_id: this.data.orderId
      },
      success: function (res) { }
    })
  }
  saveOrderInfo = () => {
    this.setData({
      changeOrder: false
    })
  }
  turnToAddDish = () => {
    if (this.franchisee_id) {
      let that = this
      app.showModal({
        title: '温馨提示',
        content: '子店商品继续点菜只能跳转子店首页或者连锁首页',
        showCancel: true,
        confirm: function () {
          that.goToHomepage()
        }
      })
      return
    }
    if (this.data.pageData.location_id) {
      app.globalData.ec_location_id = this.data.pageData.location_id
    }
    let form = JSON.parse(this.path)
    let action = form.action
    customEvent.clickEventHandler[action] &&
      customEvent.clickEventHandler[action](form, '', '')
  }
  goToHomepage = () => {
    let that = this
    let franchiseeId = that.franchisee_id
    let chainId = app.getChainId()
    if (franchiseeId && franchiseeId != chainId) {
      let pages = app.getCurrentPages()
      let p = pages[pages.length - 2]
      if (p && p.route == 'franchisee/pages/goodsMore/goodsMore') {
        app.turnBack({ delta: 2 })
      } else {
        customEvent.clickEventHandler['to-franchisee']({
          'franchisee-id': franchiseeId
        })
      }
    } else {
      var router = app.getHomepageRouter()
      app.reLaunch({ url: '/pages/' + router + '/' + router })
    }
  }
  getCalculationInfo = callback => {
    var _this = this
    app.sendRequest({
      url: '/index.php?r=AppShop/calculationPrice',
      method: 'post',
      data: {
        dining_order_id: this.data.orderId,
        ecommerce_info: {
          ec_dining_data: {
            ordering_food_type: 1, // 点餐方式
            dining_mode: _this.data.pageData.dining_mode, // 就餐方式
            people_num: _this.data.pageData.people_num, // 就餐人数
            take_meal_type: _this.data.pageData.take_meal_type, // 取餐类型
            location_id: _this.data.pageData.location_id, // 座位号码
            account_type: _this.data.pageData.account_type // 结账方式
          }
        },
        sub_shop_app_id: this.franchisee_id,
        is_balance: this.data.pageData.useBalance ? 1 : 0,
        selected_benefit: this.data.pageData.selectDiscountInfo,
        pick_up_type: 4, // 写死 后面改
        voucher_coupon_goods_info: this.data.exchangeCouponData
          .voucher_coupon_goods_info
      },
      success: function (res) {
        let info = res.data
        let benefits = info.can_use_benefit
        let goods_info = info.goods_info
        let additional_info_goods = []
        let selectDiscountInfo = info.selected_benefit_info
        let suppInfoArr = []
        let additional_goodsid_arr = []
        let newData = {}
        let goodsBenefitsData = []
        benefits.coupon_benefit && benefits.coupon_benefit.length
          ? goodsBenefitsData.push({
            label: 'coupon',
            value: benefits.coupon_benefit
          })
          : ''
        benefits.all_vip_benefit && benefits.all_vip_benefit.length
          ? goodsBenefitsData.push({
            label: 'vip',
            value: benefits.all_vip_benefit
          })
          : ''
        Array.isArray(benefits.integral_benefit)
          ? ''
          : benefits.integral_benefit &&
          goodsBenefitsData.push({
            label: 'integral',
            value: [benefits.integral_benefit]
          })
        if (
          selectDiscountInfo.discount_type == 'coupon' &&
          selectDiscountInfo.type == 3 &&
          _this.data.exchangeCouponData.hasSelectGoods == false
        ) {
          _this.exchangeCouponInit(parseInt(selectDiscountInfo.value))
        }
        goods_info.forEach(item => {
          if (
            item.delivery_id &&
            item.delivery_id != 0 &&
            additional_goodsid_arr.indexOf(item.goods_id) == -1
          ) {
            suppInfoArr.push(item.delivery_id)
            additional_goodsid_arr.push(item.goods_id)
            additional_info_goods.push(item)
          }
        })
        newData['pageData.box_fee'] = info.box_fee
        newData['pageData.server_fee'] = info.server_fee
        newData['pageData.tissue_fee'] = info.tissue_fee
        newData['pageData.discountList'] = goodsBenefitsData
        newData['pageData.selectDiscountInfo'] = selectDiscountInfo
        newData['pageData.discount_cut_price'] = info.discount_cut_price
        newData['pageData.total_discount_cut_price'] =
          info.total_discount_cut_price
        newData['pageData.balance'] = info.balance
        newData['pageData.deduction'] = info.use_balance
        newData['pageData.original_price'] = info.original_price
        newData['pageData.totalPayment'] = _this.readyCount
          ? info.price
          : info.order_amount_price
        newData['pageData.additional_goodsid_arr'] = additional_goodsid_arr
        _this.setData(newData)
        app.setPreviewGoodsInfo(additional_info_goods)
        typeof callback == 'function' && callback()
      }
    })
  }
  showMemberDiscount = () => {
    this.memberDiscountRef.current.show({
      discountType: this.data.pageData.discountList,
      afterSelectedDiscount: (event) => {
        this.afterSelectedBenefit(event)
      }
    })
    this.memberDiscountRef.current.showDialog(this.data.pageData.selectDiscountInfo);
  }
  afterSelectedBenefit = ({selectedDiscount}) => {
    this.setData({
      'pageData.selectDiscountInfo': selectedDiscount,
      'exchangeCouponData.hasSelectGoods': false,
      'exchangeCouponData.voucher_coupon_goods_info': {}
    })
    this.getCalculationInfo()
  }
  useBalanceChange = checked => {
    this.setData({
      'pageData.useBalance': e.target.value
    })
    this.getCalculationInfo()
  }
  exchangeCouponInit = id => {
    var _this = this
    app.sendRequest({
      url: '/index.php?r=AppShop/getGoods',
      data: {
        data_id: id
      },
      success: function (res) {
        var goods = res.data[0].form_data
        var goodsModel = []
        var selectModelInfo = {
          models: [],
          price: 0,
          modelId: '',
          models_text: '',
          imgurl: ''
        }
        if (goods.model_items.length) {
          selectModelInfo['price'] = Number(goods.model_items[0].price)
          selectModelInfo['imgurl'] = goods.model_items[0].img_url
          selectModelInfo['modelId'] = goods.model_items[0].id
        } else {
          selectModelInfo['price'] = Number(goods.price)
          selectModelInfo['imgurl'] = goods.cover
        }
        for (var key in goods.model) {
          if (key) {
            goodsModel.push(goods.model[key]) // 转成数组
            selectModelInfo['models'].push(goods.model[key].subModelId[0])
            selectModelInfo['models_text'] +=
              '“' + goods.model[key].subModelName[0] + '” '
          }
        }
        goods.model = goodsModel // 将原来的结构转换成数组
        _this.setData({
          'exchangeCouponData.dialogHidden': false, // 显示模态框
          'exchangeCouponData.goodsInfo': goods,
          'exchangeCouponData.selectModelInfo': selectModelInfo
        })
      },
      successStatusAbnormal: function () {
        app.showModal({
          content: '兑换的商品已下架'
        })
      }
    })
  }
  exchangeCouponHideDialog = () => {
    this.setData({
      'pageData.selectDiscountInfo': {
        title: '不使用优惠',
        name: '无',
        no_use_benefit: 1
      },
      'exchangeCouponData.dialogHidden': true,
      'exchangeCouponData.hasSelectGoods': false,
      'exchangeCouponData.voucher_coupon_goods_info': {}
    })
    this.getCalculationInfo()
  }
  exchangeCouponSelectSubModel = e => {
    var dataset = e.target.dataset,
      modelIndex = dataset.modelIndex,
      submodelIndex = dataset.submodelIndex,
      data = {},
      selectModels = this.data.exchangeCouponData.selectModelInfo.models,
      model = this.data.exchangeCouponData.goodsInfo.model,
      text = ''
    selectModels[modelIndex] = model[modelIndex].subModelId[submodelIndex]
    for (let i = 0; i < selectModels.length; i++) {
      let selectSubModelId = model[i].subModelId
      for (let j = 0; j < selectSubModelId.length; j++) {
        if (selectModels[i] == selectSubModelId[j]) {
          text += '“' + model[i].subModelName[j] + '” '
        }
      }
    }
    data['exchangeCouponData.selectModelInfo.models'] = selectModels
    data['exchangeCouponData.selectModelInfo.models_text'] = text
    this.setData(data)
    this.exchangeCouponResetSelectCountPrice()
  }
  exchangeCouponResetSelectCountPrice = () => {
    var _this = this,
      selectModelIds = this.data.exchangeCouponData.selectModelInfo.models.join(
        ','
      ),
      modelItems = this.data.exchangeCouponData.goodsInfo.model_items,
      data = {}
    for (var i = modelItems.length - 1; i >= 0; i--) {
      if (modelItems[i].model == selectModelIds) {
        data['exchangeCouponData.selectModelInfo.stock'] = modelItems[i].stock
        data['exchangeCouponData.selectModelInfo.price'] = modelItems[i].price
        data['exchangeCouponData.selectModelInfo.modelId'] = modelItems[i].id
        data['exchangeCouponData.selectModelInfo.imgurl'] =
          modelItems[i].img_url
        break
      }
    }
    this.setData(data)
  }
  exchangeCouponConfirmGoods = () => {
    let _this = this
    let goodsInfo = _this.data.exchangeCouponData.goodsInfo
    let model = goodsInfo.model
    let selectModels = _this.data.exchangeCouponData.selectModelInfo.models
    let model_value_str = ''
    if (selectModels.length > 0) {
      for (let i = 0; i < selectModels.length; i++) {
        let selectSubModelId = model[i].subModelId
        for (let j = 0; j < selectSubModelId.length; j++) {
          if (selectModels[i] == selectSubModelId[j]) {
            model_value_str += model[i].subModelName[j] + '； '
          }
        }
      }
    }
    goodsInfo['model_value_str'] = model_value_str
    _this.setData({
      'exchangeCouponData.dialogHidden': true,
      'exchangeCouponData.selectModelInfo': {},
      'exchangeCouponData.hasSelectGoods': true,
      'exchangeCouponData.voucher_coupon_goods_info': {
        goods_id: goodsInfo.id,
        num: 1,
        model_id: _this.data.exchangeCouponData.selectModelInfo.modelId
      },
      'exchangeCouponData.goodsInfo': goodsInfo
    })
    _this.getCalculationInfo()
  }
  cancelPayment = () => {
    this.setData({
      'pageData.selectDiscountInfo': {},
      exchangeCouponData: {},
      changeOrder: false,
      showBenefitInfo: false
    })
    this.getOrderDetail()
  }
  confirmPayment = e => {
    let _this = this
    let form_id = e.detail.formId || ''
    form_id && this.saveFormId(form_id)
    if (this.requesting) {
      return
    }
    this.requesting = true
    app.sendRequest({
      url: '/index.php?r=AppShop/addCartOrder',
      method: 'post',
      data: {
        dining_order_id: this.data.orderId,
        formId: e.detail.formId,
        sub_shop_app_id: this.franchisee_id,
        selected_benefit: this.data.pageData.selectDiscountInfo,
        is_balance: this.data.pageData.useBalance ? 1 : 0,
        ecommerce_info: {
          ec_dining_data: {
            ordering_food_type: 1, // 点餐方式
            dining_mode: _this.data.pageData.dining_mode, // 就餐方式
            people_num: _this.data.pageData.people_num, // 就餐人数
            take_meal_type: _this.data.pageData.take_meal_type, // 取餐类型
            location_id: _this.data.pageData.location_id, // 座位号码
            account_type: _this.data.pageData.account_type // 结账方式
          }
        },
        pick_up_type: 4, // 写死 后面改
        dining_order_id: this.data.orderId,
        remark: this.data.pageData.orderInfo.orderRemark,
        voucher_coupon_goods_info: this.data.exchangeCouponData
          .voucher_coupon_goods_info
      },
      success: function (res) {
        _this.setData({
          'pageData.totalPayment': res.total_price
        })
        if (!_this.data.pageData.allow_app_account) return
        _this.payOrder(res.data)
      },
      fail: function () {
        _this.requesting = false
      },
      successStatusAbnormal: function () {
        _this.requesting = false
      }
    })
  }
  goPayOrder = () => {
    this.payOrder(this.data.orderId)
  }
  payOrder = orderId => {
    var _this = this
    function paySuccess() {
      var pagePath =
        '/eCommerce/pages/goodsOrderPaySuccess/goodsOrderPaySuccess?detail=' +
        orderId +
        (_this.franchisee_id ? '&franchisee=' + _this.franchisee_id : '') +
        '&is_group=' +
        !!_this.is_group
      if (!_this.franchisee_id) {
        app.sendRequest({
          url: '/index.php?r=AppMarketing/CheckAppCollectmeStatus',
          data: {
            order_id: orderId,
            sub_app_id: _this.franchisee_id
          },
          success: function (res) {
            if (res.valid == 0) {
              pagePath += '&collectBenefit=1'
            }
            app.turnToPage(pagePath, 1)
          }
        })
      } else {
        app.turnToPage(pagePath, 1)
      }
    }
    function payFail() {
      if (_this.is_group) {
        if (_this.data.teamToken) {
          app.turnBack()
          return
        }
        app.turnToPage(
          '/eCommerce/pages/groupOrderDetail/groupOrderDetail?id=' +
          orderId +
          (_this.franchisee_id ? '&franchisee=' + _this.franchisee_id : ''),
          1
        )
      } else {
        if (_this.pickUpType == 4) {
          _this.getOrderDetail()
          _this.setData({
            changeOrder: false,
            showBenefitInfo: false
          })
          return
        }
        app.turnToPage(
          '/eCommerce/pages/goodsOrderDetail/goodsOrderDetail?detail=' +
          orderId +
          (_this.franchisee_id ? '&franchisee=' + _this.franchisee_id : ''),
          1
        )
      }
    }
    if (this.data.pageData.totalPayment == 0) {
      app.sendRequest({
        url: '/index.php?r=AppShop/paygoods',
        data: {
          order_id: orderId,
          total_price: 0
        },
        success: function (res) {
          paySuccess()
        },
        fail: function () {
          payFail()
        },
        successStatusAbnormal: function () {
          payFail()
        }
      })
      return
    }
    // app.sendRequest({
    //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
    //   data: {
    //     order_id: orderId
    //   },
    //   success: function (res) {
    //     var param = res.data
    //     param.orderId = orderId
    //     param.success = paySuccess
    //     param.goodsType = 0
    //     param.fail = payFail
    //     _this.wxPay(param)
    //   },
    //   fail: function () {
    //     payFail()
    //   },
    //   successStatusAbnormal: function () {
    //     payFail()
    //   }
    // })
    
    // TODO:支付成功回调要考虑一下怎么处理
    app.goPay({
      orderId: orderId
    });
  }
  // wxPay = param => {
  //   var _this = this
  //   app.requestPayment({
  //     timeStamp: param.timeStamp,
  //     nonceStr: param.nonceStr,
  //     package: param.package,
  //     signType: param.signType,
  //     paySign: param.paySign,
  //     success: function (res) {
  //       app.wxPaySuccess(param)
  //       param.success()
  //     },
  //     fail: function (res) {
  //       if (res.errMsg === 'requestPayment:fail cancel') {
  //         app.showModal({
  //           content: '支付已取消',
  //           complete: param.fail
  //         })
  //         return
  //       }
  //       app.showModal({
  //         content: '支付失败',
  //         complete: param.fail
  //       })
  //       app.wxPayFail(param, res.errMsg)
  //     }
  //   })
  // }
  setClipboardData = e => {
    let content = e.currentTarget.dataset.content
    app.setClipboardData({
      data: content
    })
  }
  callPhone = event => {
    app.callPhone(event)
  }
  showMoreGoods = () => {
    this.setData({
      showMoreGoods: !this.data.showMoreGoods
    })
  }
  getDiningBaseSetting = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppEcommerce/getPickUpGoodsTypeSetting',
      data: {
        pick_up_type: 4,
        sub_shop_app_id: that.franchisee_id
      },
      success: function (res) {
        that.setData({
          app_store_data: res.data.app_store_data
        })
      }
    })
  }
  getDiningFuncSetting = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppEcommerce/getFuncSetting',
      data: {
        sub_shop_app_id: this.franchisee_id,
        ordering_food_type: 1, //1.堂食 2.预约
        pick_up_type: 4
      },
      success: function (res) {
        ; (that.path = res.data.add_dish_info.page || ''),
          that.setData({
            'pageData.allow_add_dish':
              res.data.add_dish_info.allow_app_status == 1 ? true : false,
            'pageData.allow_app_account': res.data.account_info.account_way[1]
              ? true
              : false
          })
      }
    })
  }
  saveFormId = form_id => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=api/AppMsgTpl/SaveUserFormId',
      data: {
        form_id: form_id
      },
      method: 'post',
      success: function (res) {
        console.log(res)
      }
    })
  }
  readyCount = false
  showBenefitInfo = e => {
    this.getOrderDetail()
    if (
      this.data.pageData.ec_dining_data.account_type == 2 &&
      this.data.pageData.orderInfo.status == 17
    ) {
      this.getCalculationInfo(this.afterShowBeneft)
      this.readyCount = true
    }
  }
  afterShowBeneft = () => {
    this.setData({
      showBenefitInfo: true,
      changeOrder: true
    })
  }
  goToAdditionalInfo = () => {
    app.setGoodsAdditionalInfo(this.data.pageData.additional_info)
    app.turnToPage(
      '/eCommerce/pages/goodsAdditionalInfo/goodsAdditionalInfo?from=diningOrderDetail'
    )
  }
  modifyTime = orderInfo => {
    let newData = {}
      ; (newData['pageData.add_time'] = util.formatTimeYMD(
        orderInfo.add_time,
        'YYYY-MM-DD'
      )),
        (newData['pageData.payment_time'] = util.formatTimeYMD(
          orderInfo.payment_time
        ))
    this.data.pageData.diningOrderList.forEach((item, index) => {
      newData[
        'pageData.diningOrderList[' + index + '].add_time'
      ] = util.formatTimeYMD(item.add_time, 'hh:mm:ss')
    })
    this.setData(newData)
  }
  showVipGoodsList = () => {
    this.setData({
      showVipGoodsList: true
    })
  }
  hideVipGoodsList = () => {
    this.setData({
      showVipGoodsList: false
    })
  }

  render() {
    const {
      showGetUserInfo,
      pageData,
      showNoticeModal,
      orderId,
      changeOrder,
      showMoreBtn,
      showBtnNum,
      showBenefitInfo,
      hasAdditionalInfo,
      customNumArr,
      app_store_data,
      showMoreGoods,
      userToken,
      exchangeCouponData,
      balance,
      franchisee_id,
      dialogHidden,
      selectModelInfo,
      goodsInfo,
      storeStyle,
      vip_goods_list,
      showVipGoodsList
    } = this.state

    return (
      <React.Fragment>
        <div className="official-page dining-order-detail">
          <TopNav title="订单详情" />
          <div className="dining-wrapper">
            <div className="order-bg-wrapper">
              <div className="order-bg-pic"></div>
              {showNoticeModal && (
                <div
                  className="dining-notice"
                  hidden={pageData.ec_dining_data.take_meal_type == 2}
                >
                  <span className="ico-moon icon-community-report dining-notice-icon"></span>
                  <span>您已下单成功，请不要轻易换桌！</span>
                  <span
                    className="ico-moon icon-closes dining-notice-close"
                    onClick={this.showNoticeModalFn}
                  ></span>
                </div>
              )}
              <div
                className="dining-order-status  flex-between"
                style={convertLineStyleData('padding-top:' + (showNoticeModal ? '50' : '40') + 'rpx;')}
              >
                {pageData.account_type == 1 && !changeOrder && (
                  <React.Fragment>
                    {pageData.orderInfo.status == 0 ? (
                      <div className="order-info">
                        <div
                          className="order-info-title"
                          onClick={this.goOrderProgress}
                        >
                          <span>待付款</span>
                          <span
                            className="ico-moon icon-rightarrow"
                            style={convertLineStyleData('font-size:32rpx;margin-left:10rpx;color:#fff;')}
                          ></span>
                        </div>
                        <span className="order-info-tips">
                          20分钟内未付款，将自动取消订单
                        </span>
                      </div>
                    ) : pageData.orderInfo.status == 3 ? (
                      <div className="order-info">
                        <div
                          className="order-info-title"
                          onClick={this.goOrderProgress}
                        >
                          <span>待评价</span>
                          <span
                            className="ico-moon icon-rightarrow"
                            style={convertLineStyleData('font-size:32rpx;margin-left:10rpx;color:#fff;')}
                          ></span>
                        </div>
                        {pageData.ec_dining_data.duration_time > 0 && (
                          <span className="order-info-tips">
                            {'预计等待' +
                              pageData.ec_dining_data.duration_time +
                              '分钟'}
                          </span>
                        )}
                      </div>
                    ) : pageData.orderInfo.status == 6 ? (
                      <div className="order-info">
                        <div
                          className="order-info-title"
                          onClick={this.goOrderProgress}
                        >
                          <span>已完成</span>
                          <span
                            className="ico-moon icon-rightarrow"
                            style={convertLineStyleData('font-size:32rpx;margin-left:10rpx;color:#fff;')}
                          ></span>
                        </div>
                      </div>
                    ) : pageData.orderInfo.status == 7 ? (
                      <div className="order-info">
                        <div
                          className="order-info-title"
                          onClick={this.goOrderProgress}
                        >
                          <span>已关闭</span>
                          <span
                            className="ico-moon icon-rightarrow"
                            style={convertLineStyleData('font-size:32rpx;margin-left:10rpx;color:#fff;')}
                          ></span>
                        </div>
                      </div>
                    ) : (
                              pageData.orderInfo.status == 8 && (
                                <div className="order-info">
                                  <div
                                    className="order-info-title"
                                    onClick={this.goOrderProgress}
                                  >
                                    <span>待商家接单</span>
                                    <span
                                      className="ico-moon icon-rightarrow"
                                      style={convertLineStyleData('font-size:32rpx;margin-left:10rpx;color:#fff;')}
                                    ></span>
                                  </div>
                                  <span className="order-info-tips">
                                    15分钟内商家未接单，将自动取消订单
                          </span>
                                </div>
                              )
                            )}
                    {/*  订单按钮 先付后吃  */}
                    <div className="order-operate-box">
                      {(pageData.orderInfo.status == 6 ||
                        pageData.orderInfo.status == 3 ||
                        pageData.orderInfo.status == 7) && (
                          <div
                            className="order-operate"
                            onClick={this.orderDelete}
                          >
                            删除订单
                        </div>
                        )}
                      {pageData.orderInfo.status == 0 && (
                        <div
                          className="order-operate change"
                          style={convertLineStyleData('height:56rpx;')}
                          onClick={this.goPayOrder}
                        >
                          立即支付
                        </div>
                      )}
                      {pageData.orderInfo.status == 3 && (
                        <div
                          className="order-operate change"
                          data-id={orderId}
                          onClick={this.turnToComment}
                        >
                          立即评价
                        </div>
                      )}
                      {!!+pageData.ec_dining_data.has_reduce_dishes && (
                        <div
                          className="order-operate change"
                          onClick={this.turnToRufundDish}
                        >
                          退款详情
                        </div>
                      )}
                    </div>
                  </React.Fragment>
                )}
                {pageData.account_type == 2 && !changeOrder && !showBenefitInfo && (
                  <React.Fragment>
                    {pageData.orderInfo.status == 0 && (
                      <div className="order-info">
                        <div
                          className="order-info-title"
                          onClick={this.goOrderProgress}
                        >
                          <span>待付款</span>
                          <span
                            className="ico-moon icon-rightarrow"
                            style={convertLineStyleData('font-size:32rpx;margin-left:10rpx;color:#fff;')}
                          ></span>
                        </div>
                      </div>
                    )}
                    {pageData.orderInfo.status == 17 ? (
                      <div className="order-info">
                        <div
                          className="order-info-title"
                          onClick={this.goOrderProgress}
                        >
                          <span>已下单</span>
                          <span
                            className="ico-moon icon-rightarrow"
                            style={convertLineStyleData('font-size:32rpx;margin-left:10rpx;color:#fff;')}
                          ></span>
                        </div>
                        {pageData.ec_dining_data.duration_time > 0 && (
                          <span className="order-info-tips">
                            {'预计等待' +
                              pageData.ec_dining_data.duration_time +
                              '分钟'}
                          </span>
                        )}
                      </div>
                    ) : pageData.orderInfo.status == 16 ? (
                      <div className="order-info">
                        <div
                          className="order-info-title"
                          onClick={this.goOrderProgress}
                        >
                          <span>待商家接单</span>
                          <span
                            className="ico-moon icon-rightarrow"
                            style={convertLineStyleData('font-size:32rpx;margin-left:10rpx;color:#fff;')}
                          ></span>
                        </div>
                        <span className="order-info-tips">
                          15分钟内商家未接单，将自动取消订单
                        </span>
                      </div>
                    ) : pageData.orderInfo.status == 7 ? (
                      <div className="order-info">
                        <div
                          className="order-info-title"
                          onClick={this.goOrderProgress}
                        >
                          <span>已关闭</span>
                          <span
                            className="ico-moon icon-rightarrow"
                            style={convertLineStyleData('font-size:32rpx;margin-left:10rpx;color:#fff;')}
                          ></span>
                        </div>
                      </div>
                    ) : pageData.orderInfo.status == 3 ? (
                      <div className="order-info">
                        <div
                          className="order-info-title"
                          onClick={this.goOrderProgress}
                        >
                          <span>待评价</span>
                          <span
                            className="ico-moon icon-rightarrow"
                            style={convertLineStyleData('font-size:32rpx;margin-left:10rpx;color:#fff;')}
                          ></span>
                        </div>
                      </div>
                    ) : (
                              pageData.orderInfo.status == 6 && (
                                <div className="order-info">
                                  <div
                                    className="order-info-title"
                                    onClick={this.goOrderProgress}
                                  >
                                    <span>已完成</span>
                                    <span
                                      className="ico-moon icon-rightarrow"
                                      style={convertLineStyleData('font-size:32rpx;margin-left:10rpx;color:#fff;')}
                                    ></span>
                                  </div>
                                </div>
                              )
                            )}
                    {/*  订单按钮 先吃后付  */}
                    <div className="order-operate-box">
                      {showBtnNum == 3 && (
                        <div
                          className="order-operate showMoreBtn"
                          onClick={this.showMoreBtn}
                        >
                          <div>
                            <span>更多</span>
                            <span
                              className={
                                'ico-moon ' +
                                (showMoreBtn ? 'icon-uparrow' : 'icon-downarrow')
                              }
                              style={convertLineStyleData('font-size:24rpx;margin-left:10rpx;')}
                            ></span>
                          </div>
                          <div className="moreBtn-box" hidden={!showMoreBtn}>
                            {pageData.orderInfo.status == 17 && (
                              <div
                                style={convertLineStyleData('color:#FE782F;')}
                                onClick={this.changeDiningOrder}
                              >
                                修改订单
                              </div>
                            )}
                            {(pageData.orderInfo.status == 0 ||
                              pageData.orderInfo.status == 17) && (
                                <div
                                  style={convertLineStyleData('height:56rpx;top:120rpx;color:#FE782F;')}
                                  onClick={
                                    pageData.orderInfo.status == 0
                                      ? 'goPayOrder'
                                      : 'showBenefitInfo'
                                  }
                                  hidden={!pageData.allow_app_account}
                                >
                                  立即支付
                              </div>
                              )}
                            {pageData.orderInfo.status == 3 && (
                              <div
                                style={convertLineStyleData('color:#FE782F;')}
                                data-id={orderId}
                                onClick={this.turnToComment}
                              >
                                立即评价
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {pageData.orderInfo.status == 17 && (
                        <div
                          className="order-operate"
                          onClick={this.changeDiningOrder}
                          hidden={showBtnNum == 3}
                        >
                          修改订单
                        </div>
                      )}
                      {pageData.ec_dining_data.has_reduce_dishes && (
                        <div
                          className="order-operate change"
                          onClick={this.turnToRufundDish}
                        >
                          退菜详情
                        </div>
                      )}
                      {(pageData.orderInfo.status == 6 ||
                        pageData.orderInfo.status == 3 ||
                        pageData.orderInfo.status == 7) && (
                          <div
                            className="order-operate"
                            onClick={this.orderDelete}
                          >
                            删除订单
                        </div>
                        )}
                      {(pageData.orderInfo.status == 0 ||
                        (pageData.orderInfo.status == 17 && showBtnNum != 3)) && (
                          <div
                            className="order-operate change"
                            style={convertLineStyleData('height:56rpx;')}
                            onClick={
                              pageData.orderInfo.status == 0
                                ? 'goPayOrder'
                                : 'showBenefitInfo'
                            }
                            hidden={!pageData.allow_app_account}
                          >
                            立即支付
                        </div>
                        )}
                      {pageData.orderInfo.status == 3 && showBtnNum != 3 && (
                        <div
                          className="order-operate"
                          data-id={orderId}
                          onClick={this.turnToComment}
                        >
                          立即评价
                        </div>
                      )}
                      {pageData.orderInfo.status == 17 &&
                        pageData.allow_add_dish && (
                          <div
                            className="order-operate change"
                            onClick={this.turnToAddDish}
                          >
                            加菜
                          </div>
                        )}
                      {(pageData.orderInfo.status == 16 ||
                        pageData.orderInfo.status == 8) && (
                          <div
                            className="order-operate cancel"
                            onClick={this.orderCancel}
                          >
                            取消订单
                        </div>
                        )}
                    </div>
                  </React.Fragment>
                )}
              </div>
            </div>
            {/*  座号  */}
            <div
              className="eating-place-wrapper"
              style={convertLineStyleData(
                'margin-top:' +
                (changeOrder || showBenefitInfo ? '-160' : '-100') +
                'rpx;'
              )}
            >
              <div className="half-shadow" style={convertLineStyleData('left: 0rpx;')}></div>
              <div className="half-shadow" style={convertLineStyleData('right: -60rpx;')}></div>
              <div className="eating-type flex-between">
                <div>
                  {pageData.ec_dining_data && pageData.ec_dining_data.dining_mode == 1 ? '堂食' : '打包'}
                </div>
                <div style={convertLineStyleData('font-weight:bold;color:#333;font-size:28rpx;')}>
                  {pageData.ec_dining_data && pageData.ec_dining_data.take_meal_type == 1
                    ? '送餐到桌'
                    : '前台自取'}
                </div>
              </div>
              <div className="eating-place-num">
                <div className="eating-num-item">
                  <div
                    style={convertLineStyleData('font-size:68rpx;')}
                    className={
                      'ellipsis ' +
                      (pageData.ec_dining_data && pageData.ec_dining_data.take_meal_type == 2
                        ? 'max_width'
                        : 'limit_width')
                    }
                  >
                    {(pageData.ec_dining_data && pageData.ec_dining_data.formatted_queue_num) || '------'}
                  </div>
                  <div style={convertLineStyleData('color:#666;')}>流水号</div>
                </div>
                {pageData.location_id && (
                  <div className="eating-num-item">
                    <div
                      style={convertLineStyleData('font-size:68rpx;')}
                      className="ellipsis limit_width"
                    >
                      {pageData.ec_dining_data.location_name || '------'}
                    </div>
                    <div style={convertLineStyleData('color:#666;')}>桌号</div>
                  </div>
                )}
              </div>
              <div className="eating-info-detail">
                <div
                  className="flex-between"
                  style={convertLineStyleData(
                    !(pageData.orderInfo && pageData.orderInfo.remark) && !hasAdditionalInfo
                      ? ''
                      : 'margin-bottom:20rpx;'
                  )}
                >
                  <div style={convertLineStyleData('color:#999;')}>就餐人数</div>
                  {changeOrder && (
                    <Picker
                      className="eating-picker"
                      onChange={this.changeCustomNum}
                      range={customNumArr}
                    >
                      <span style={convertLineStyleData('font-weight:bold;')}>
                        {(pageData.people_num || 1) + '人'}
                      </span>
                      <span className="ico-moon icon-rightarrow icon-right"></span>
                    </Picker>
                  )}
                  {!changeOrder && <div>{pageData.people_num + '人'}</div>}
                </div>
                <div
                  hidden={!(pageData.orderInfo && pageData.orderInfo.remark)}
                  className="flex-between"
                  style={convertLineStyleData(!hasAdditionalInfo ? '' : 'margin-bottom:20rpx;')}
                >
                  <div style={convertLineStyleData('color:#999;')}>订单备注</div>
                  <div>{(pageData.orderInfo && pageData.orderInfo.remark) || '无'}</div>
                </div>
                {hasAdditionalInfo && (
                  <div
                    className="flex-between"
                    onClick={this.goToAdditionalInfo}
                  >
                    <div style={convertLineStyleData('color:#999;')}>补充信息</div>
                    <span className="ico-moon icon-rightarrow icon-right"></span>
                  </div>
                )}
              </div>
            </div>
            {/*  订单详情  */}
            <div className="dining-shop-box">
              <div className="dining-shop flex-between">
                <span style={convertLineStyleData('font-size:28rpx;font-weight:bold;')}>
                  {app_store_data && app_store_data.title}
                </span>
                <span
                  className="ico-moon icon-fn-phone icon-right"
                  style={convertLineStyleData('font-size:44rpx;')}
                  data-phone={app_store_data && app_store_data.contact_phone}
                  onClick={this.callPhone}
                ></span>
              </div>
            </div>
            {/*  商品列表  */}
            <div className="order-info-wrapper">
              <div
                style={convertLineStyleData(
                  'height:' +
                  (pageData.goodsSum < 4 || showMoreGoods ? '' : '240rpx') +
                  ';overflow:hidden;'
                )}
              >
                {pageData.diningOrderList && pageData.diningOrderList.map((orderData, index) => {
                  return (
                    <div className="order-info-box" key="order_index">
                      {orderData.child_form_data.map((item, key) => {
                        return (
                          <React.Fragment key={item.buyer_info.buyer_id}>
                            <div className="custom-info-wrapper flex-between">
                              <div className="flex-between">
                                {orderData.from_admin == 1 ? (
                                  <div className="custom-info">
                                    <img src="http://cdn.jisuapp.cn/static/webapp/images/xcx-dining/default.png" />
                                  </div>
                                ) : (
                                    orderData.from_admin == 0 && (
                                      <div className="custom-info">
                                        <img
                                          src={item.buyer_info.cover_thumb}
                                        />
                                      </div>
                                    )
                                  )}
                                <span
                                  className="custom-name"
                                  data-id={item.buyer_info.buyer_id}
                                >
                                  {item.buyer_info.nickname +
                                    (item.buyer_info.buyer_id == userToken
                                      ? '（我）'
                                      : '') +
                                    (orderData.from_admin == 1 ? '（商家）' : '')}
                                </span>
                              </div>
                              <span className="custom-selected">
                                {orderData.add_time}
                              </span>
                            </div>
                            <div className="goods-info-wrapper">
                              {item.goods_list.map((goods, index) => {
                                return (
                                  <React.Fragment key={index}>
                                    {!!+goods.reduced_num && (
                                      <div
                                        className="goods-info-item"
                                        style={convertLineStyleData(
                                          index == 0 &&
                                            pageData.goodsSum > 3 &&
                                            !showMoreGoods
                                            ? 'border-bottom:0;padding-bottom:0;'
                                            : ''
                                        )}
                                      >
                                        <div className="goods-image">
                                          <img
                                            src={goods.cover}
                                            mode="aspectFill"
                                          />
                                        </div>
                                        <div className="goods-detail">
                                          <div className="flex-between">
                                            <div
                                              style={convertLineStyleData('max-width:400rpx;')}
                                              className="ellipsis"
                                            >
                                              {goods.max_can_use_integral > 0 && (
                                                <span className="goods-special">
                                                  积
                                                </span>
                                              )}
                                              {goods.is_seckill == 1 && (
                                                <span className="goods-special">
                                                  秒杀
                                                </span>
                                              )}
                                              <span
                                                className="goods-name"
                                                style={convertLineStyleData('text-decoration:line-through;')}
                                              >
                                                {goods.goods_name}
                                              </span>
                                            </div>
                                            {orderData.status == 10 ? (
                                              <span className="goods-status2">
                                                已拒绝
                                              </span>
                                            ) : orderData.status == 40 ? (
                                              <span className="goods-status2">
                                                已关闭
                                              </span>
                                            ) : (
                                                  (orderData.status == 0 ||
                                                    orderData.status == 20 ||
                                                    orderData.status == 30) && (
                                                    <span className="goods-status2">
                                                      {pageData.account_type == 1
                                                        ? '已退款'
                                                        : '已退菜'}
                                                    </span>
                                                  )
                                                )}
                                          </div>
                                          {goods.model_value_str && (
                                            <div className="goods-type">
                                              <div className="type-size ellipsis">
                                                {goods.model_value_str}
                                              </div>
                                            </div>
                                          )}
                                          <div className="goods-price flex-between">
                                            <div className="price-box">
                                              <span className="priceNow">
                                                <span style={convertLineStyleData('font-size:20rpx;')}>
                                                  ¥
                                                </span>
                                                {goods.price}
                                              </span>
                                              {/*  <text class='priceNow'><text style='font-size:20rpx;'>¥</text>{{ pageData.orderInfo.is_vip_order == 1 && goods.is_vip_goods ? goods.vip_price : goods.price}}</text>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                <text class='dinning_vip_tips' wx:if="{{ pageData.orderInfo.is_vip_order == 1 && goods.is_vip_goods}}">会员价</text>  */}
                                              {!pageData.orderInfo && (
                                                <span className="priceBefore">
                                                  <span style={convertLineStyleData('font-size:20rpx;')}>
                                                    ￥
                                                  </span>
                                                  {goods.virtual_price || 0}
                                                </span>
                                              )}
                                            </div>
                                            <div style={convertLineStyleData('color:#999;font-size:24rpx;')}>
                                              <span
                                                className="ico-moon icon-closes"
                                                style={convertLineStyleData('font-size:20rpx;')}
                                              ></span>
                                              {goods.reduced_num}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                    {!!+goods.num && (
                                      <div
                                        className="goods-info-item"
                                        style={convertLineStyleData(
                                          index == 0 &&
                                            pageData.goodsSum > 3 &&
                                            !showMoreGoods
                                            ? 'border-bottom:0;padding-bottom:0;'
                                            : ''
                                        )}
                                      >
                                        <div className="goods-image">
                                          <img
                                            src={goods.cover}
                                            mode="aspectFill"
                                          />
                                        </div>
                                        <div className="goods-detail">
                                          <div className="flex-between">
                                            <div
                                              style={convertLineStyleData('max-width:400rpx;')}
                                              className="ellipsis"
                                            >
                                              {goods.max_can_use_integral > 0 && (
                                                <span className="goods-special">
                                                  积
                                                </span>
                                              )}
                                              {goods.is_seckill == 1 && (
                                                <span className="goods-special">
                                                  秒杀
                                                </span>
                                              )}
                                              <span className="goods-name">
                                                {goods.goods_name}
                                              </span>
                                            </div>
                                            {(orderData.status == 20 ||
                                              orderData.status == 30) && (
                                                <span className="goods-status3">
                                                  已出厨
                                              </span>
                                              )}
                                          </div>
                                          {goods.model_value_str && (
                                            <div className="goods-type">
                                              <div className="type-taste ellipsis">
                                                {goods.model_value_str}
                                              </div>
                                            </div>
                                          )}
                                          <div className="goods-price flex-between">
                                            <div className="price-box">
                                              <span className="priceNow">
                                                <span style={convertLineStyleData('font-size:20rpx;')}>
                                                  ¥
                                                </span>
                                                {goods.price}
                                              </span>
                                              {/*  <text class='priceNow'><text style='font-size:20rpx;'>¥</text>{{ pageData.orderInfo.is_vip_order == 1 && goods.is_vip_goods ? goods.vip_price : goods.price}}</text>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              <text class='dinning_vip_tips' wx:if="{{ pageData.orderInfo.is_vip_order == 1 && goods.is_vip_goods}}">会员价</text>  */}
                                              {!pageData.orderInfo && (
                                                <span className="priceBefore">
                                                  <span style={convertLineStyleData('font-size:20rpx;')}>
                                                    ￥
                                                  </span>
                                                  {goods.virtual_price || 0}
                                                </span>
                                              )}
                                            </div>
                                            {!pageData.orderInfo && (
                                              <div className="calculate-wrapper">
                                                <div
                                                  className="calculate-sub"
                                                  onClick={this.subGoods}
                                                  data-key={key}
                                                  data-index={index}
                                                  data-value={goods.goodsNum}
                                                >
                                                  -
                                                </div>
                                                <div className="calculate-num">
                                                  {goods.goodsNum}
                                                </div>
                                                <div
                                                  className="calculate-add"
                                                  onClick={this.addGoods}
                                                  data-key={key}
                                                  data-index={index}
                                                  data-value={goods.goodsNum}
                                                >
                                                  +
                                                </div>
                                              </div>
                                            )}
                                            {pageData.orderInfo && (
                                              <div style={convertLineStyleData('color:#999;font-size:24rpx;')}>
                                                <span
                                                  className="ico-moon icon-closes"
                                                  style={convertLineStyleData('font-size:20rpx;')}
                                                ></span>
                                                {goods.num}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </React.Fragment>
                                )
                              })}
                            </div>
                          </React.Fragment>
                        )
                      })}
                    </div>
                  )
                })}
              </div>
              {pageData.goodsSum > 3 && (
                <div className="goods-showMore">
                  <div
                    className="goods-more"
                    hidden={showMoreGoods}
                    onClick={this.showMoreGoods}
                  >
                    展开更多<span className="ico-moon icon-downarrow"></span>
                  </div>
                  <div
                    className="goods-more"
                    hidden={!showMoreGoods}
                    onClick={this.showMoreGoods}
                  >
                    点击收起<span className="ico-moon icon-uparrow"></span>
                  </div>
                </div>
              )}
              {exchangeCouponData.hasSelectGoods &&
                !exchangeCouponData.selectModelInfo.is_refunded && (
                  <div className="goods-voucher">
                    <div className="goods-image">
                      <img
                        src={exchangeCouponData.goodsInfo.cover}
                        mode="aspectFill"
                      />
                    </div>
                    <div className="goods-detail">
                      <div className="flex-between">
                        <div style={convertLineStyleData('max-width:400rpx;')} className="ellipsis">
                          <span className="goods-special">赠品</span>
                          <span className="goods-name">
                            {exchangeCouponData.goodsInfo.title}
                          </span>
                        </div>
                      </div>
                      {goods.model_value_str && (
                        <div className="goods-type">
                          <div className="type-taste ellipsis">
                            {goods.model_value_str}
                          </div>
                        </div>
                      )}
                      <div style={convertLineStyleData('text-align: right;')}>x1</div>
                    </div>
                  </div>
                )}
              <div
                className="other-price-wrapper"
                style={convertLineStyleData('margin-bottom:' + (showBenefitInfo ? '20rpx' : '') + ';')}
              >
                <div
                  className="other-price-item flex-between"
                  hidden={pageData.tissue_fee == 0}
                >
                  <span>纸巾费</span>
                  <span>{'￥' + pageData.tissue_fee}</span>
                </div>
                {pageData.ec_dining_data && pageData.ec_dining_data.dining_mode == 1 ? (
                  <div
                    className="other-price-item flex-between"
                    hidden={pageData.server_fee == 0}
                  >
                    <span>服务费</span>
                    <span>{'￥' + pageData.server_fee}</span>
                  </div>
                ) : (
                    (pageData.ec_dining_data && pageData.ec_dining_data.dining_mode == 2) && (
                      <div
                        className="other-price-item flex-between"
                        hidden={pageData.box_fee == 0}
                      >
                        <span>包装费</span>
                        <span>{'￥' + pageData.box_fee}</span>
                      </div>
                    )
                  )}
                <div className="discounted-item flex-between">
                  <div className="discounted-item-detail">
                    <span style={convertLineStyleData('font-size:24rpx;')}>商品金额</span>
                  </div>
                  <span>{'￥' + (pageData.orderInfo && pageData.orderInfo.total_original_price)}</span>
                </div>
                {pageData.account_type == 1 ? (
                  <React.Fragment>
                    {!(pageData.orderInfo.status == 7) && pageData.show_benefit_info && (
                      <div className="discounted-item flex-between">
                        <div className="discounted-item-detail">
                          <span className="other-type">优惠</span>
                          <span style={convertLineStyleData('font-size:24rpx;')}>
                            {pageData.orderInfo.selected_benefit_info.name}
                          </span>
                        </div>
                        <span style={convertLineStyleData('color:#ff7100;')}>
                          {'￥' + pageData.orderInfo.discount_cut_price}
                        </span>
                      </div>
                    )}
                    {/*  <view class='discounted-item flex-between' wx:if="{{pageData.orderInfo.is_vip_order == 1 && pageData.orderInfo.vip_cut_price != '0.00'}}" style={convertLineStyleData('padding-bottom:0;')}>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                <view class='discounted-item-detail'>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  <text class='other-type'>优惠</text>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  <text style='font-size:24rpx;'>会员价</text>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                </view>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                <text style='color:#ff7100;'>-¥{{pageData.orderInfo.vip_cut_price}}</text>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              </view>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              <view class='discounted-item vip_goods_detail' wx:if="{{pageData.orderInfo.is_vip_order == 1 && pageData.orderInfo.vip_cut_price != '0.00'}}" catchtap="showVipGoodsList" style={convertLineStyleData('margin-bottom:20rpx;')}>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                <view class="ico-moon icon-rightarrow pull-right"></view>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                <text class="pull-right select-discount">查看详情</text>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              </view>  */}
                    {pageData.orderInfo.use_balance > 0 && (
                      <div className="discounted-item flex-between">
                        <div className="discounted-item-detail">
                          <span className="other-type">储值</span>
                          <span style={convertLineStyleData('font-size:24rpx;')}>储值优惠</span>
                        </div>
                        <span style={convertLineStyleData('color:#ff7100;')}>
                          {'-¥' + pageData.orderInfo.use_balance}
                        </span>
                      </div>
                    )}
                  </React.Fragment>
                ) : (
                    ((pageData.account_type == 2 &&
                      pageData.orderInfo &&
                      pageData.orderInfo.status == 0) ||
                      pageData.orderInfo && 
                      pageData.orderInfo.status == 3 ||
                      pageData.orderInfo &&
                      pageData.orderInfo.status == 6) && (
                      <React.Fragment>
                        {pageData.show_benefit_info && (
                          <div className="discounted-item flex-between">
                            <div className="discounted-item-detail">
                              <span className="other-type">优惠</span>
                              <span style={convertLineStyleData('font-size:24rpx;')}>
                                {pageData.orderInfo.selected_benefit_info.name}
                              </span>
                            </div>
                            <span style={convertLineStyleData('color:#ff7100;')}>
                              {'￥' +
                                pageData.orderInfo.selected_benefit_info
                                  .discount_price}
                            </span>
                          </div>
                        )}
                        {/*  <view class='discounted-item flex-between' wx:if="{{pageData.orderInfo.is_vip_order == 1 && pageData.orderInfo.vip_cut_price != '0.00'}}" style={convertLineStyleData('padding-bottom:0;')}>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          <view class='discounted-item-detail'>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            <text class='other-type'>优惠</text>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            <text style='font-size:24rpx;'>会员价</text>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          </view>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          <text style='color:#ff7100;'>-￥{{pageData.orderInfo.vip_cut_price}}</text>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        </view>  */}
                        {/*  <view class='discounted-item vip_goods_detail' wx:if="{{pageData.orderInfo.is_vip_order == 1 && pageData.orderInfo.vip_cut_price != '0.00'}}" catchtap="showVipGoodsList" style={convertLineStyleData('margin-bottom:20rpx;')}>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                <view class="ico-moon icon-rightarrow pull-right"></view>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                <text class="pull-right select-discount">查看详情</text>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              </view>  */}
                        {pageData.orderInfo.use_balance > 0 && (
                          <div className="discounted-item flex-between">
                            <div className="discounted-item-detail">
                              <span className="other-type">储值</span>
                              <span style={convertLineStyleData('font-size:24rpx;')}>储值优惠</span>
                            </div>
                            <span style={convertLineStyleData('color:#ff7100;')}>
                              {'-￥' + pageData.orderInfo.use_balance}
                            </span>
                          </div>
                        )}
                      </React.Fragment>
                    )
                  )}
                {((pageData.orderInfo && pageData.orderInfo.is_vip_order == 1 &&
                  pageData.orderInfo.vip_cut_price != '0.00' &&
                  !showBenefitInfo) ||
                  !pageData.discountList.length) && (
                    <div
                      className="discounted-item flex-between"
                      style={convertLineStyleData('padding-bottom:0;')}
                    >
                      <div className="discounted-item-detail">
                        <span className="other-type">优惠</span>
                        <span style={convertLineStyleData('font-size:24rpx;')}>会员价</span>
                      </div>
                      <span style={convertLineStyleData('color:#ff7100;')}>
                        {'-¥' + (pageData.orderInfo && pageData.orderInfo.vip_cut_price)}
                      </span>
                    </div>
                  )}
                {((pageData.orderInfo && pageData.orderInfo.is_vip_order == 1 &&
                  pageData.orderInfo.vip_cut_price != '0.00' &&
                  !showBenefitInfo) ||
                  !pageData.discountList.length) && (
                    <div
                      className="discounted-item vip_goods_detail"
                      onClick={this.showVipGoodsList}
                      style={convertLineStyleData('margin-bottom:20rpx;')}
                    >
                      <div className="ico-moon icon-rightarrow pull-right"></div>
                      <span className="pull-right select-discount">查看详情</span>
                    </div>
                  )}
              </div>
              {showBenefitInfo && (
                <div
                  className="payment-wrapper"
                  hidden={!pageData.discountList.length}
                >
                  {pageData.orderInfo.is_vip_order == 1 &&
                    pageData.orderInfo.vip_cut_price != '0.00' && (
                      <div
                        className="discounted-item flex-between"
                        style={convertLineStyleData('padding-bottom:0;padding-top:30rpx;border:none;')}
                      >
                        <div className="discounted-item-detail">
                          <span className="other-type">优惠</span>
                          <span style={convertLineStyleData('font-size:24rpx;')}>会员价</span>
                        </div>
                        <span style={convertLineStyleData('color:#ff7100;')}>
                          {'-¥' + pageData.orderInfo.vip_cut_price}
                        </span>
                      </div>
                    )}
                  {pageData.orderInfo.is_vip_order == 1 &&
                    pageData.orderInfo.vip_cut_price != '0.00' && (
                      <div
                        className="discounted-item vip_goods_detail"
                        onClick={this.showVipGoodsList}
                      >
                        <div className="ico-moon icon-rightarrow pull-right"></div>
                        <span className="pull-right select-discount">
                          查看详情
                        </span>
                      </div>
                    )}
                  <div
                    className="discounts-item flex-between"
                    style={convertLineStyleData('align-items:baseline;')}
                    onClick={this.showMemberDiscount}
                  >
                    <span>优惠方式</span>
                    <div className="discounts-type">
                      <div className="discounts-name">
                        <div
                          className="ellipsis"
                          style={convertLineStyleData('max-width:400rpx;display:inline-block;')}
                        >
                          {pageData.selectDiscountInfo.title}
                        </div>
                        <span className="ico-moon icon-rightarrow icon-right"></span>
                      </div>
                      <div className="discounts-price">
                        {'-￥' +
                          (pageData.selectDiscountInfo.discount_cut_price || 0)}
                      </div>
                    </div>
                  </div>
                  {balance != 0 && !franchisee_id && (
                    <div
                      className="discounts-item flex-between"
                      style={convertLineStyleData('align-items: flex-start;')}
                    >
                      <span className="discounts-name" style={convertLineStyleData('margin-top:14rpx;')}>
                        使用储值金
                      </span>
                      <div className="discounts-type">
                        <Switch
                          color="#FF7100"
                          style={convertLineStyleData('transform:scale(.75);margin-right:-20rpx;')}
                          checked={pageData.useBalance}
                          onChange={this.useBalanceChange}
                        ></Switch>
                        <div
                          hidden={!pageData.useBalance}
                          className="balance-price"
                        >
                          <span className="pull-right" style={convertLineStyleData('color:#FF7100;')}>
                            {'- ¥' + pageData.deduction}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
              <div className="price-count-box" hidden={showBenefitInfo}>
                <div className="price-count">
                  {pageData.orderInfo && pageData.orderInfo.total_discount_cut_price > 0 && (
                    <span style={convertLineStyleData('color:#999;font-size:26rpx;margin-right:28rpx;')}>
                      {'已优惠¥' +
                        pageData.orderInfo.total_discount_cut_price +
                        '元'}
                    </span>
                  )}
                  <span style={convertLineStyleData('font-size:28rpx;vertical-align:text-bottom;')}>
                    总计:
                  </span>
                  <span style={convertLineStyleData('font-size:40rpx;color:#ff7100;')}>
                    {'￥' + pageData.totalPayment}
                  </span>
                </div>
              </div>
              {/*  订单信息  */}
              <div className="order-baseInfo">
                <div className="baseInfo-item flex-between">
                  <span style={convertLineStyleData('color:#666;')}>下单日期</span>
                  <span style={convertLineStyleData('color:#999;')}>{pageData.add_time}</span>
                </div>
                {pageData.orderInfo && !!+pageData.orderInfo.payment_time && (
                  <div className="baseInfo-item flex-between">
                    <span style={convertLineStyleData('color:#666;')}>支付时间</span>
                    <span style={convertLineStyleData('color:#999;')}>{pageData.payment_time}</span>
                  </div>
                )}
                <div className="baseInfo-item flex-between">
                  <span style={convertLineStyleData('color:#666;')}>订单编号</span>
                  <div>
                    <span style={convertLineStyleData('color:#999;')}>{orderId}</span>
                    <span style={convertLineStyleData('margin:0 20rpx;width:1px;height:20rpx;background-color:#f1f1f1;display:inline-block;')}></span>
                    <span
                      style={convertLineStyleData('color:#ff7100;')}
                      onClick={this.setClipboardData}
                      data-content={orderId}
                    >
                      复制
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {/* TODO
            <ExchangeCouponUseDialogTmpl
              data={exchangeCouponData}
            ></ExchangeCouponUseDialogTmpl> */}
            {pageData.account_type == 2 && (
              <React.Fragment>
                {changeOrder && !showBenefitInfo && (
                  <div className="changeOrder-wrapper all-price-box">
                    {pageData.allow_add_dish && (
                      <div
                        className="changeOrder add"
                        onClick={this.turnToAddDish}
                        hidden={!pageData.location_id}
                      >
                        加菜
                      </div>
                    )}
                    <div
                      className="changeOrder"
                      style={convertLineStyleData('color:#ff7100;padding:0 25rpx;')}
                      onClick={this.showBenefitInfo}
                      hidden={!pageData.allow_app_account}
                    >
                      保存并支付
                    </div>
                    <div
                      className="changeOrder save"
                      onClick={this.saveOrderInfo}
                      hidden={showBenefitInfo}
                      style={convertLineStyleData(
                        !pageData.allow_app_account && !pageData.allow_add_dish
                          ? 'flex:1;'
                          : ''
                      )}
                    >
                      保存
                    </div>
                  </div>
                )}
                {showBenefitInfo && (
                  <div
                    className="all-price-box flex-between"
                    hidden={!changeOrder}
                  >
                    <div className="all-price">
                      <span style={convertLineStyleData('white-space:nowrap;')}>合计：</span>
                      <span
                        className="all-price-now priceNow ellipse"
                        style={convertLineStyleData('color:' + storeStyle.theme + ';max-width:200rpx;')}
                      >
                        {'￥' + pageData.totalPayment}
                      </span>
                      <span
                        className="discounted-price"
                        style={convertLineStyleData('background-color:' + storeStyle.theme + ';')}
                      >
                        {'已优惠¥' + pageData.total_discount_cut_price}
                      </span>
                    </div>
                    <div className="flex-between">
                      <div className="cancel_pay" onClick={this.cancelPayment}>
                        取消
                      </div>
                      <form reportSubmit="true" onSubmit={this.confirmPayment}>
                        <button
                          formType="submit"
                          className="all-price-calculate"
                          style={convertLineStyleData(
                            'background-color:' +
                            storeStyle.theme +
                            '; width:190rpx;border-radius:0;'
                          )}
                        >
                          去结算
                        </button>
                      </form>
                    </div>
                  </div>
                )}
              </React.Fragment>
            )}
          </div>
          {/*  会员商品列表 start  */}
          {showVipGoodsList && (
            <div className="vip_goods_mask" onClick={this.hideVipGoodsList}>
              <div className="vipGoodsWarp">
                {pageData.orderInfo.dining_vip_card_info && (
                  <div className="custom-info-wrapper flex-between">
                    <div className="flex-between">
                      <div className="custom-info">
                        <img
                          src={
                            pageData.orderInfo.dining_vip_card_info.cover_thumb
                          }
                        />
                      </div>
                      <span className="custom-name">
                        {pageData.orderInfo.dining_vip_card_info.title}
                      </span>
                    </div>
                    <div className="pull-right">
                      <span className="cut_price_tip">优惠</span>
                      <span className="vip_cut_price">
                        {'-¥' + pageData.orderInfo.vip_cut_price}
                      </span>
                    </div>
                  </div>
                )}
                <div className="goods-info-wrapper">
                  {vip_goods_list.map((goods, index) => {
                    return (
                      <React.Fragment key="items">
                        {!!+goods.refunded_num && (
                          <div
                            className="goods-info-item"
                            style={convertLineStyleData(
                              index == 0 &&
                                pageData.goodsSum > 3 &&
                                !showMoreGoods
                                ? 'border-bottom:0;padding-bottom:0;'
                                : ''
                            )}
                          >
                            <div className="goods-image">
                              <img src={goods.cover} mode="aspectFill" />
                            </div>
                            <div className="goods-detail">
                              <div className="flex-between">
                                <div
                                  style={convertLineStyleData('max-width:400rpx;')}
                                  className="ellipsis"
                                >
                                  {goods.max_can_use_integral > 0 && (
                                    <span className="goods-special">积</span>
                                  )}
                                  {goods.is_seckill == 1 && (
                                    <span className="goods-special">秒杀</span>
                                  )}
                                  <span
                                    className="goods-name"
                                    style={convertLineStyleData('text-decoration:line-through;')}
                                  >
                                    {goods.goods_name}
                                  </span>
                                </div>
                                {orderData.status == 10 ? (
                                  <span className="goods-status2">已拒绝</span>
                                ) : (
                                    orderData.status == 40 && (
                                      <span className="goods-status2">已关闭</span>
                                    )
                                  )}
                                <span className="goods-status2">已退</span>
                              </div>
                              {goods.model_value_str && (
                                <div className="goods-type">
                                  <div className="type-size ellipsis">
                                    {goods.model_value_str}
                                  </div>
                                </div>
                              )}
                              <div className="goods-price flex-between">
                                <div className="price-box">
                                  <span className="priceNow">
                                    <span style={convertLineStyleData('font-size:20rpx;')}>¥</span>
                                    {goods.price}
                                  </span>
                                  {pageData.orderInfo.is_vip_order == 1 &&
                                    goods.is_vip_goods && (
                                      <span className="dinning_vip_tips">
                                        会员价
                                      </span>
                                    )}
                                  <span
                                    className="priceBefore"
                                    style={convertLineStyleData('margin-left:12rpx;font-size:28rpx;text-decoration:none;')}
                                  >
                                    <span style={convertLineStyleData('font-size:20rpx;')}>¥</span>
                                    {goods.original_price}
                                  </span>
                                </div>
                                <div style={convertLineStyleData('color:#999;font-size:24rpx;')}>
                                  <span
                                    className="ico-moon icon-closes"
                                    style={convertLineStyleData('font-size:20rpx;')}
                                  ></span>
                                  {goods.refunded_num}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {goods.count && (
                          <div
                            className="goods-info-item"
                            style={convertLineStyleData(
                              index == 0 &&
                                pageData.goodsSum > 3 &&
                                !showMoreGoods
                                ? 'border-bottom:0;padding-bottom:0;'
                                : ''
                            )}
                          >
                            <div className="goods-image">
                              <img src={goods.cover} mode="aspectFill" />
                            </div>
                            <div className="goods-detail">
                              <div className="flex-between">
                                <div
                                  style={convertLineStyleData('max-width:400rpx;')}
                                  className="ellipsis"
                                >
                                  {goods.max_can_use_integral > 0 && (
                                    <span className="goods-special">积</span>
                                  )}
                                  {goods.is_seckill == 1 && (
                                    <span className="goods-special">秒杀</span>
                                  )}
                                  <span className="goods-name">
                                    {goods.goods_name}
                                  </span>
                                </div>
                                {(orderData.status == 20 ||
                                  orderData.status == 30) && (
                                    <span className="goods-status3">已出厨</span>
                                  )}
                              </div>
                              {goods.model_value_str && (
                                <div className="goods-type">
                                  <div
                                    className="type-taste ellipsis"
                                    style={convertLineStyleData('max-width:400rpx;')}
                                  >
                                    {goods.model_value_str}
                                  </div>
                                </div>
                              )}
                              <div className="goods-price flex-between">
                                <div className="price-box">
                                  <span className="priceNow">
                                    <span style={convertLineStyleData('font-size:20rpx;')}>¥</span>
                                    {goods.price}
                                  </span>
                                  {pageData.orderInfo.is_vip_order == 1 &&
                                    goods.is_vip_goods && (
                                      <span className="dinning_vip_tips">
                                        会员价
                                      </span>
                                    )}
                                  <span
                                    className="priceBefore"
                                    style={convertLineStyleData('margin-left:12rpx;font-size:28rpx;text-decoration:none;')}
                                  >
                                    <span style={convertLineStyleData('font-size:20rpx;')}>¥</span>
                                    {goods.original_price}
                                  </span>
                                </div>
                                {!pageData.orderInfo && (
                                  <div className="calculate-wrapper">
                                    <div
                                      className="calculate-sub"
                                      onClick={this.subGoods}
                                      data-key={key}
                                      data-index={index}
                                      data-value={goods.goodsNum}
                                    >
                                      -
                                    </div>
                                    <div className="calculate-num">
                                      {goods.goodsNum}
                                    </div>
                                    <div
                                      className="calculate-add"
                                      onClick={this.addGoods}
                                      data-key={key}
                                      data-index={index}
                                      data-value={goods.goodsNum}
                                    >
                                      +
                                    </div>
                                  </div>
                                )}
                                {pageData.orderInfo && (
                                  <div style={convertLineStyleData('color:#999;font-size:24rpx;')}>
                                    <span
                                      className="ico-moon icon-closes"
                                      style={convertLineStyleData('font-size:20rpx;')}
                                    ></span>
                                    {goods.count}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </React.Fragment>
                    )
                  })}
                </div>
              </div>
            </div>
          )}
          {/*  会员商品列表 end  */}
        </div>
        <MemberDiscount ref={this.memberDiscountRef} />
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/dining-order-detail/DiningOrderDetail.jsx